import React from 'react';
import { Link } from 'react-router-dom';
import SEOHead from '../seo/SEOHead';

const galleryImages = [
  '/images/gallery-01.jpg',
  '/images/gallery-02.jpg',
  '/images/gallery-03.jpg',
  '/images/gallery-04.jpg',
  '/images/gallery-05.jpg',
  '/images/gallery-06.jpg',
  '/images/gallery-07.jpg',
  '/images/gallery-08.jpg',
  '/images/gallery-09.jpg',
  '/images/gallery-10.jpg',
  '/images/gallery-11.jpg',
  '/images/gallery-12.jpg',
  '/images/gallery-13.jpg',
  '/images/gallery-14.jpg',
  '/images/gallery-15.jpg',
  '/images/gallery-16.jpg',
];

const Home = () => {
  return (
    <>
      <SEOHead path="/" />

      {/* Hero */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-badge fade-in">Faith-Based 501(c)(3) Non-Profit</div>
          <h1 className="fade-in delay-1">
            Putting Hope <span className="gold">Within Reach</span> of Every Addict
          </h1>
          <p className="fade-in delay-2">
            Bringing hope, healing, and Christ-centered transformation to individuals and families affected by addiction, trauma, and homelessness in Armenia.
          </p>
          <Link to="/donate" className="hero-cta fade-in delay-3">
            Give Hope — Donate Today →
          </Link>
        </div>
      </section>

      {/* Ministries */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="overline">What We Do</span>
            <h2>Our Active Ministries</h2>
            <p>Reaching those whom no one else reaches — with faith, love, and tangible support across Armenia.</p>
          </div>

          <div className="ministries-grid">
            {[
              {
                icon: '🏠',
                title: "Men's Rehabilitation Center",
                desc: "A faith-based ministry offering yearlong support, healing addicted men through biblical teachings, life skills, work ethic, and family reconciliation.",
                to: '/mens-rehabilitation-center'
              },
              {
                icon: '👨‍👩‍👧‍👦',
                title: 'Orphanage Ministry',
                desc: "Compassionate ministry hosting orphans in our own home, integrating them with our family for a supportive and stable upbringing.",
                to: '/orphanage-ministry'
              },
              {
                icon: '🤝',
                title: 'Ministry for Vulnerable People',
                desc: "Supporting financially insecure families faced with tuberculosis or AIDS, offering post-treatment care, nutritious sustenance, medication, and disease control to avoid wider spread.",
                to: '/ministry-for-needy'
              },
              {
                icon: '🍞',
                title: 'Ministry for Homeless People',
                desc: "A compassionate outreach initiative offering food, clothing, and hope to the homeless through prayer, love, and spreading the Gospel's message of salvation.",
                to: '/ministry-for-homeless-people'
              },
              {
                icon: '🏥',
                title: 'Ministry for People with Acute Infectious Diseases',
                desc: "Dedicated to aiding the homeless affected by severe infections, we ensure hospital care, followed by support with nourishment, clothing, and medication recovery services.",
                to: '/ministry-for-people-with-acute-infectious-diseases'
              },
              {
                icon: '🌍',
                title: 'Ministry for Refugees',
                desc: "Upholding Leviticus 19:34, our organization aids newcomers in securing housing, employment, and societal integration, fostering a welcoming community for displaced individuals.",
                to: '/ministry-for-refugees'
              },
            ].map((m, i) => (
              <Link to={m.to} key={i} className={`ministry-card fade-in delay-${i + 1}`} style={{ textDecoration: 'none' }}>
                <div className="card-icon">{m.icon}</div>
                <h3>{m.title}</h3>
                <p>{m.desc}</p>
                <span className="card-link">Learn more →</span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section section-alt">
        <div className="container">
          <div className="section-header">
            <span className="overline">Our People</span>
            <h2>Meet Our Team</h2>
          </div>

          <div className="team-grid">
            {[
              {
                img: '/images/team-gagik.jpg',
                name: 'Gagik and Lusine Mkrtchyans',
                role: 'Gagik is the Director of Teen Challenge Armenia'
              },
              {
                img: '/images/team-edik.png',
                name: 'Edik Saghatelyan',
                role: "Edik is the head of Men's Rehabilitation Center"
              },
              {
                img: '/images/team-david.jpg',
                name: 'David Manukyan',
                role: 'David is in charge of construction works'
              },
              {
                img: '/images/team-arman.jpg',
                name: 'Arman & Gohar Avchyans',
                role: 'Arman & Gohar are leading the Outreach and Medical care Ministries'
              },
            ].map((t, i) => (
              <div key={i} className={`team-card fade-in delay-${i + 1}`}>
                <img src={t.img} alt={t.name} />
                <h4>{t.name}</h4>
                <p>{t.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Activity Gallery */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="overline">In Action</span>
            <h2>Activity of our Ministries</h2>
          </div>

          <div className="gallery-grid">
            {galleryImages.map((img, i) => (
              <div key={i} className="gallery-item fade-in">
                <img src={img} alt={`Ministry activity ${i + 1}`} loading="lazy" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section section-alt" style={{ textAlign: 'center' }}>
        <div className="container">
          <div className="section-header">
            <span className="overline">Make a Difference</span>
            <h2>Your Support Changes Lives</h2>
            <p>Every donation helps us reach those whom no one else reaches. Together, we can bring hope and transformation to those who need it most.</p>
          </div>
          <Link to="/donate" className="hero-cta">
            Donate Now →
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home;
